var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.625H10.4219L9.08594 5.98438C8.78125 6.26562 8.78125 6.75781 9.08594 7.03906C9.22656 7.17969 9.41406 7.25 9.625 7.25C9.8125 7.25 10 7.17969 10.1406 7.03906L12.7656 4.41406C13.0703 4.13281 13.0703 3.64062 12.7656 3.35938L10.1406 0.734375C9.85938 0.429688 9.36719 0.429688 9.08594 0.734375C8.78125 1.01562 8.78125 1.50781 9.08594 1.78906L10.4219 3.125H1.75C1.32812 3.125 1 3.47656 1 3.875C1 4.29688 1.32812 4.625 1.75 4.625ZM12.25 8.375H3.55469L4.89062 7.03906C5.19531 6.75781 5.19531 6.26562 4.89062 5.98438C4.60938 5.67969 4.11719 5.67969 3.83594 5.98438L1.21094 8.60938C0.90625 8.89062 0.90625 9.38281 1.21094 9.66406L3.83594 12.2891C3.97656 12.4297 4.16406 12.5 4.375 12.5C4.5625 12.5 4.75 12.4297 4.89062 12.2891C5.19531 12.0078 5.19531 11.5156 4.89062 11.2344L3.55469 9.875H12.25C12.6484 9.875 13 9.54688 13 9.125C13 8.72656 12.6484 8.375 12.25 8.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch-icon.b9b76b99599fd1f2592cf4c83d6ebe53.svg";
export { ForwardRef as ReactComponent };